<template>
  <div id="adminSettingUser">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url" v-on:click.native="cancelNewUser">{{ users }}</router-link>
      </li>
        <li
        style="
          float: right;
          position: absolute;
          right: 15px;
          float: right;
          position: absolute;
          right: 15px;
          font-weight: bold;
          font-size: 20px;
          color: #303c54;
          text-transform: uppercase;
          margin-top: -5px;
        "
      >
        {{ nameUser }}
      </li>
    </ol>
      <div class="container-fluid card-title-admin">
      <div class="row">
        <div class="col-6">
             <h1>{{ users }}</h1>
         </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabAdminSettingUser" role="tabpanel" style="box-shadow:none!important;">
              <div class="tab-content noborder">
                <div class="tab-pane active" id="tabUserBody" role="tabpanel">
                  <div class="row align-btns">
                    <div class="col-lg-12">
                      <button
                        id="btnAdd"
                        type="button"
                        class="btn btn-primary"
                        @click="onTabNewUser"
                      >
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                      <button
                        id="btnSave"
                        type="button"
                        class="btn btn-success"
                        @click="confirmSaveUser"
                        :disabled="disableButton"
                      >
                      <i class="fa fa-floppy-o"></i>
                        <span>{{ save }}</span>
                      </button>
            
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <bootstrapTable
                        :configurations="tableUsersConfiguration"
                        :datas="tableUserData"
                        id="tableUser"
                        :onCheck="onTableCheckUser"
                        :onCheckAll="onTableCheckUser"
                        :onUncheck="onTableCheckUser"
                        :onUncheckAll="onTableCheckUser"
                        ref="tableUser"
                        :results="tableUserResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="tabGroupBody" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableGroupsEnabledConfiguration"
                        :datas="tableGroupsEnabledData"
                        id="tableGroupsEnabled"
                        :onCheck="onTableGroupsEnabledCheck"
                        :onCheckAll="onTableGroupsEnabledCheck"
                        :onUncheck="onTableGroupsEnabledCheck"
                        :onUncheckAll="onTableGroupsEnabledCheck"
                        ref="tableGroupsEnabled"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            @click="addGroup"
                            :disabled="disableAddGroupButton"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            @click="removeGroup"
                            :disabled="disableRemoveGroupButton"
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableGroupsDisabledConfiguration"
                        :datas="tableGroupsDisabledData"
                        id="tableGroupsDisabled"
                        :onCheck="onTableGroupsDisabledCheck"
                        :onCheckAll="onTableGroupsDisabledCheck"
                        :onUncheck="onTableGroupsDisabledCheck"
                        :onUncheckAll="onTableGroupsDisabledCheck"
                        ref="tableGroupsDisabled"
                        :results="tableUserResult"
                      ></bootstrapTable>                  
                    </div>
                  </div>
                </div>
              </div>
            </div>
        
          <div class="tab-pane" id="tabNewUserBody" role="tabpanel" style="box-shadow:none!important;">
              <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabadminSettingUserButton"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabadminSettingUserButton"
                        role="tab"
                        aria-controls="tabadminSettingUserButton"
                        v-on:click="ontabadminSettingUserButton"  
                      >
                        <i class=""></i>
                        <span>Anagrafica</span>
                      </button>
                    </li>
                      <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingAddressButton"
                        class="nav-link"
                        type="button"
                        data-toggle="tab"
                        href="#tabadminSettingAddressButton"
                        role="tab"
                        aria-controls="tabadminSettingAddressButton"
                        v-on:click="ontabadminSettingAddressButton"  
                      >
                        <i class=""></i>
                        <span>Indirizzi di Spedizione</span>
                      </button>
                    </li>
                      <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminRoleSettings"
                      class="nav-link"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminRoleSettings"
                      role="tab"
                      aria-controls="tabAdminRoleSettings"
                      v-on:click="ontabAdminRoleSettings"
                    >
                      <span>Gruppi e Ruoli</span>
                    </button>
                  </li>
                   <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingUserReferentButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabadminSettingUserReferentButton"
                        role="tab"
                        aria-controls="tabadminSettingUserReferentButton"  
                        v-on:click="ontabadminSettingUserReferentButton"          
                      >
                        <i class=""></i>
                        <span>Referenti</span>
                      </button>
                    </li>
                     <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingSalesUserButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabadminSettingSalesUserButton"
                        role="tab"
                        aria-controls="tabadminSettingSalesUserButton"  
                        v-on:click="ontabadminSettingSalesUserButton"          
                      >
                        <i class=""></i>
                        <span>Vendita</span>
                      </button>
                    </li>
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingUserhistorical"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabadminSettingUserhistoricalButton"
                        role="tab"
                        aria-controls="tabadminSettingUserhistoricalButton"  
                        v-on:click="ontabadminSettingUserhistoricalButton"          
                      >
                        <i class=""></i>
                        <span>Storico</span>
                      </button>
                    </li>
                     <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabadminSettingUserTimeLine"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabadminSettingUserTimeLineButton"
                        role="tab"
                        aria-controls="tabadminSettingUserTimeLineButton"  
                        v-on:click="ontabadminSettingUserTimeLineButton"          
                      >
                        <i class=""></i>
                        <span>Timeline</span>
                      </button>
                    </li>
                    </ul>
            <div class="tab-content">
              <div class="card-body active tab-pane " id="detailUser"  role="tabpanel" style="padding:2rem;box-shadow:none!important;padding-top: 0px;">
              <div class="row">
              <div v-if="rowIdSelected > 0">
              <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica Utente</h1>
              </div>
              <div v-else>
              <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi Utente</h1>
              </div>
                <pageDetail
                  functions="adminSettingUser"
                  :configurations="detailConfigurations"
                  :jsonValue="detailValues"
                ></pageDetail>
                <br>
              </div>
              <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Accesso</h1>
               <br>
                <div class="row">   
                     <div class="col-2"><input type="text" style="min-height: 56px;font-size: 16px;" class="form-control" id="username" name="username" placeholder="Username"></div> 
                      <div class="col-2">
                    <input type="password" style="min-height: 56px;font-size: 16px;" class="form-control" id="password" name="password" placeholder="Password"></div> 
                      <div class="col-2">
                  <input type="password" style="min-height: 56px;font-size: 16px;" class="form-control" id="confirm_password" name="confirm_password" placeholder="Conferma Password"></div>
                  <div class="col-4">
                  <button
                    id="ResetPassword"
                    type="button"
                    class="btn btn-success"
                    @click="ResetPassword"
                  >
                    <i class="fa fa-send"></i>
                    <span>INVIA RESET LINK</span>
                  </button>
                  <button
                    id="btnSendConfirmEmail"
                    type="button"
                    class="btn btn-success"
                    @click="ResetConfermationEmail"
                  >
                    <i class="fa fa-send"></i>
                    <span>INVIA CONFERMA</span>
                  </button>
                  </div> 
                  <div class="col-2" style="margin-top: -21px;">
                      <div class="form-check">
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin: 2px; vertical-align: bottom"
                          ><label style="font-size:12px!important;">Confermato</label>
                          <input
                            v-if="rowIdSelected > 0"
                            :id="'confirmed'"
                            type="checkbox"
                            name="confirmed"
                            class="switch-input confirmed"
                            :checked="confirmed"
                          />
                          <input
                            v-else
                            :id="'confirmed'"
                            type="checkbox"
                            name="confirmed"
                            class="switch-input confirmed"
                            checked="checked"
                          />
                            <div class="switch-slider"></div> 
                            </label
                          >&nbsp;&nbsp;
                        </div>
                      </div>         
               </div>
               <div class="row" style="margin-top: 10px;">
                 <div class="col-3" v-if="detailValues.created_at != '' && detailValues.created_at != null"><strong>Data di Registrazione</strong><br>{{detailValues.created_at}}</div>
                 <div class="col-3" v-if="detailValues.address_ip != '' && detailValues.address_ip != null"><strong>Indirizzo IP</strong><br>{{detailValues.address_ip}}</div>
               </div>
               <div style="max-height:160px;overflow: auto;">
                  <div class="row" style="margin-top: 10px;">
                      <div class="col-3" v-if="ResultLogs.length > 0"><strong>Ultimi Log In</strong></div>
                      <div class="col-3" v-if="ResultLogs.length > 0"><strong>Indirizzo IP</strong></div>
                      <div class="col-3" v-if="ResultLogs.length > 0"><strong>Username</strong></div>
                  </div>
 <div
                          v-for="ResultLogss in ResultLogs"
                          v-bind:key="ResultLogss"
                       >
               <div class="row">
               <div class="col-3">{{ResultLogss.date_login}}</div>  
               <div class="col-3">{{ResultLogss.ip}}</div> 
               <div class="col-3">{{ResultLogss.username_log}}</div>  
               </div></div></div>
              <div class="row" v-if="rowIdSelected > 0 || checkInsert">
                <div class="col-lg-12 text-right">
                  <button
                    id="btnCancelNew"
                    type="button"
                    class="btn btn-danger"
                    @click="cancelNewUser"
                  >
                    <i class="fa fa-times"></i>
                    <span>{{ cancel }}</span>
                  </button>
                  <button id="btnAddNew" type="button" class="btn btn-success" @click="saveNewUser">
                    <i class="fa fa-floppy-o"></i>
                    <span>{{ save }}</span>
                  </button>
                </div>
              </div>           
          </div>  
          </div> 
          </div> 
          <!---dettaglio Referenti --->
                <div class="card-body tab-pane" id="detailtableReferent"  role="tabpanel" style="box-shadow:none!important;padding-top: 0px;">
                           <div class="tab-content" style="border: 0px solid rgb(200, 206, 211);">
                              <div class="tab-pane" role="tabpanel" id="tableReferent" style="box-shadow:none!important;padding-top: 0px;">
                                <div class="row">                                
                              <div class="col-sm-12">
                                <bootstrapTable
                                  :configurations="UsersReferentConfiguration"
                                  :datas="tableUserReferentData"
                                  id="tableGroupDisabled"
                                  :onCheck="onTableGroupsDisabledCheck"
                                  :onCheckAll="onTableGroupsDisabledCheck"
                                  :onUncheck="onTableGroupsDisabledCheck"
                                  :onUncheckAll="onTableGroupsDisabledCheck"
                                  ref="tableGroupsDisabled"
                                  :results="tableUserReferentResult"
                                ></bootstrapTable>   
                            </div>
                            </div> 
                            <div class="container-fluid">
                          <div class="row">
                          <div class="col-12 text-right">
                             <button
                                id="btnCancelNew"
                                type="button"
                                class="btn btn-danger"
                                @click="cancelNewUser"
                              >
                                <i class="fa fa-times"></i>
                                <span>{{ cancel }}</span>
                              </button>
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="onTabNewReferent"
                            >
                              <i class="fa fa-plus"></i>
                              <span>{{ add }}</span>
                            </button>
                          </div></div>
                              </div>
                            </div>
                    <div class="card-body active tab-pane" id="detailReferent"  role="tabpanel" style="padding:2rem;box-shadow: none;padding-top: 0px;"> 
                      <div class="row">
                      <div v-if="rowIdSelectedReferent > 0">
                        <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica Referente</h1>
                        </div>
                        <div v-else>
                        <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi Referente</h1>
                        </div>
                        <pageDetail
                        functions="adminSettingUserReferent"
                        :configurations="DetailReferentConfiguration"
                        :jsonValue="detailValuesReferent"
                        ></pageDetail>
                      </div>

<!---accesso referenti --->
   <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Accesso</h1>
               <br>
                <div class="row">   
                     <div class="col-2"><input type="text" style="min-height: 56px;font-size: 16px;" class="form-control" id="username_referent" name="username_referent" placeholder="Username"></div> 
                      <div class="col-2">
                    <input type="password" style="min-height: 56px;font-size: 16px;" class="form-control" id="password_referent" name="password_referent" placeholder="Password"></div> 
                      <div class="col-2">
                  <input type="password" style="min-height: 56px;font-size: 16px;" class="form-control" id="confirm_password_referent" name="confirm_password_referent" placeholder="Conferma Password"></div>
                  <div class="col-4">
                  <button
                    id="ResetPasswordReferent"
                    type="button"
                    class="btn btn-success"
                    @click="ResetPasswordReferent"
                  >
                    <i class="fa fa-send"></i>
                    <span>INVIA RESET LINK</span>
                  </button>
                  <button
                    id="btnSendConfirmEmailReferent"
                    type="button"
                    class="btn btn-success"
                    @click="ResetConfermationEmailReferent"
                  >
                    <i class="fa fa-send"></i>
                    <span>INVIA CONFERMA</span>
                  </button>
                  </div> 
                  <div class="col-2" style="margin-top: -21px;">
                      <div class="form-check">
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin: 2px; vertical-align: bottom"
                          ><label style="font-size:12px;">Confermato</label>
                          <input
                            v-if="rowIdSelectedReferent > 0"
                            :id="'confirmed_referent'"
                            type="checkbox"
                            name="confirmed_referent"
                            class="switch-input confirmed_referent"
                            :checked="confirmed_referent"
                          />
                          <input
                            v-else
                            :id="'confirmed_referent'"
                            type="checkbox"
                            name="confirmed_referent"
                            class="switch-input confirmed_referent"
                            checked="checked"
                          />
                            <div class="switch-slider"></div> 
                            </label
                          >&nbsp;&nbsp;
                        </div>
                      </div>         
               </div>  
<!---- end accesso referenti ---> 

            <div class="row">
              <div class="col-12 text-right">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="cancelNewUsers"
                ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="saveNewReferent"
                ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
              </div>
               </div>
            </div>
          </div> 
      </div>   <!--- end dettaglio Referenti ---> 

    <div class="card-body tab-pane" id="detailRole" role="tabpanel" style="box-shadow:none!important;padding-top: 0px;">
       <div class="row">

            <!--detail gruppi --->
    <div class="col-sm-6 col-md-6" style="background: #fafafa; padding-top: 15px">
       <div class="col-6">
      <h1>Gruppi</h1></div>
         <div
                      v-for="tableDataGroupUser in tableDataUserGroup"
                      v-bind:key="tableDataGroupUser.id"
                    >
                        <div class="row">                   
                          <div class="col-1">
                            <div class="form-check">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; vertical-align: bottom"
                              >
                                <input v-if="tableDataGroupUser.checkUserGroup"
                                  type="checkbox"
                                  name="checkUserGroup"
                                  class="switch-input checkbox"
                                  checked="checked"
                                  :id="'checkUserGroup' + tableDataGroupUser.id"
                                  :data-id-related="tableDataGroupUser.id"
                                  @change="onChangeUserGroup(tableDataGroupUser.id)"/>
                                   <input v-else
                                  type="checkbox"
                                  name="checkUserGroup"
                                  class="switch-input checkbox"
                                  :id="'checkUserGroup' + tableDataGroupUser.id"
                                  :data-id-related="tableDataGroupUser.id"
                                  @change="onChangeUserGroup(tableDataGroupUser.id)"/>
                                <div class="switch-slider"></div>
                              </label>
                            </div>
                          </div>
                            <div class="col-5" style="margin-left: 15px;">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataGroupUser.description">{{ tableDataGroupUser.description }}</span>
                          </div>   
                        </div>
    </div></div>
    <!--end detail gruppi --->

<!-- dettaglio ruoli -->
          <div class="col-sm-6 col-md-6" style="background: #fafafa; padding-top: 15px">
            <div class="col-6">
             <h1>Ruoli</h1></div>
              <div
                      v-for="tableDataRoleUser in tableDataRole"
                      v-bind:key="tableDataRoleUser.id"
                    >
                        <div class="row">             
                          <div class="col-1">
                            <div class="form-check">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; vertical-align: bottom"
                              >
                                <input v-if="tableDataRoleUser.check"
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                  checked="checked"
                                  :id="'check' + tableDataRoleUser.id"
                                  :data-id-related="tableDataRoleUser.id"
                                  @change="onChangeUserRole(tableDataRoleUser.id)"/>
                                   <input v-else
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                  :id="'check' + tableDataRoleUser.id"
                                  :data-id-related="tableDataRoleUser.id"
                                  @change="onChangeUserRole(tableDataRoleUser.id)"/>
                                <div class="switch-slider"></div>
                              </label>
                            </div>
                          </div>
                            <div class="col-5" style="margin-left: 15px;">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataRoleUser.description">{{ tableDataRoleUser.description }}</span>
                          </div>   
                        </div>
    </div></div>
<!-- end dettaglio ruoli -->
    </div>
               <div class="row">
                <div class="col-lg-12 text-right">
                  <button
                    id="btnCancelNew"
                    type="button"
                    class="btn btn-danger"
                    @click="cancelNewUser"
                  >
                    <i class="fa fa-times"></i>
                    <span>{{ cancel }}</span>
                  </button>
                </div>
              </div>  
    </div>
  <!--end dettaglio gruppi e ruoli -->


 <!---dettaglio vendite --->
    <div class="card-body tab-pane" id="tabledetailSalesUser" role="tabpanel" style="box-shadow:none!important;padding: 30px;padding-top: 0px;">
                    <div class="row">
                      <div v-if="rowIdSelected> 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                        <pageDetail
                        functions="adminSettingSalesUser"
                        :configurations="detailSalesUserConfiguration"
                        :jsonValue="detailValuesSalesUser"
                        ></pageDetail>
                      </div>
                      <div class="row">
                        <div class="col-12 text-right" style="margin-top: 8px;padding: 0px;">
                          <button
                            type="button"
                            class="btn btn-danger"
                            data-dismiss="modal"
                            @click="cancelNewUser"
                          ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="saveNewSalesUser"
                          ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                          </div>
                        </div>
                        <div class="row">
                        <div class="col-6"><h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Regole del Carrello</h1></div>
                        <div class="col-6 text-right" style="padding: 0px;">  
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="executeOpenNewCartRuleUser"
                          ><i class="fa fa-plus"></i>&nbsp;Aggiungi</button></div></div>    
                          <div class="row">                                
                              <div class="col-sm-12">
                                <bootstrapTable
                                  :configurations="tableCartRulesUsersConfiguration"
                                  :datas="tableCartRulesUsersData"
                                  id="tableCartRulesUsersData"
                                  :onCheck="onTableGroupsDisabledCheck"
                                  :onCheckAll="onTableGroupsDisabledCheck"
                                  :onUncheck="onTableGroupsDisabledCheck"
                                  :onUncheckAll="onTableGroupsDisabledCheck"
                                  ref="tableCartRulesUsersData"
                                  :results="tableCartRulesUsersResult"
                                ></bootstrapTable>   
                              </div>
                            </div> 
                </div>   
  <!--- end dettaglio vendite --->


<!---dettaglio Storico --->
    <div class="card-body tab-pane" id="tabledetailUserHistorical" role="tabpanel" style="box-shadow:none!important;padding: 30px;padding-top: 0px;">
                          <div class="row">                                
                              <div class="col-sm-12">
                                <bootstrapTable
                                  :configurations="tableUserHistoricalConfiguration"
                                  :datas="tableUserHistoricalData"
                                  id="tableUserHistoricalData"
                                  :onCheck="onTableGroupsDisabledCheck"
                                  :onCheckAll="onTableGroupsDisabledCheck"
                                  :onUncheck="onTableGroupsDisabledCheck"
                                  :onUncheckAll="onTableGroupsDisabledCheck"
                                  ref="tableUserHistoricalData"
                                  :results="tableUserHistoricalResult"
                                ></bootstrapTable>   
                              </div>
                            </div>  
                               <div class="row">
                              <div class="col-lg-12 text-right">
                                <button
                                  id="btnCancelNew"
                                  type="button"
                                  class="btn btn-danger"
                                  @click="cancelNewUser"
                                >
                                  <i class="fa fa-times"></i>
                                  <span>{{ cancel }}</span>
                                </button>
                              </div>
                            </div>  
                              </div>   
  <!--- end dettaglio storico --->


     <!---dettaglio Indirizzi --->
                <div class="card-body tab-pane" id="tableAddress" role="tabpanel" style="box-shadow:none!important;padding-top: 0px;">
                           <div class="tab-content" style="border: 0px solid #c8ced3;">
                                <div class="row">                                
                              <div class="col-sm-12">
                                <bootstrapTable
                                  :configurations="tableAddressConfiguration"
                                  :datas="tableAddressData"
                                  id="tableAddressData"
                                  :onCheck="onTableGroupsDisabledCheck"
                                  :onCheckAll="onTableGroupsDisabledCheck"
                                  :onUncheck="onTableGroupsDisabledCheck"
                                  :onUncheckAll="onTableGroupsDisabledCheck"
                                  ref="tableAddressData"
                                  :results="tableAddressResult"
                                ></bootstrapTable>   
                              </div>
                            </div> 
                            <div class="container-fluid">
                          <div class="row">
                          <div class="col-12 text-right">
                             <button
                                id="btnCancelNew"
                                type="button"
                                class="btn btn-danger"
                                @click="cancelNewUser"
                              >
                                <i class="fa fa-times"></i>
                                <span>{{ cancel }}</span>
                              </button>
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="onTabNewAddress"
                            >
                              <i class="fa fa-plus"></i>
                              <span>{{ add }}</span>
                            </button>                             
                          </div>
                           </div>
                     </div>                     
                </div> 
            </div>  

    <!-- detail timeline --->
      <div class="card-body tab-pane" id="tabledetailTimeline" role="tabpanel" style="box-shadow:none!important;padding-top: 0px;">
  <div class="tab-content" style="border: 0px; background:#fff!important;">

<div class="row"> 
    <div class="col-6"> 
    <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Timeline</h1>   
    </div>
    <div class="col-5">
    <input type="text" style="min-height: 56px;font-size: 16px;" class="form-control" id="comment" name="comment" placeholder="Leave a comment..."></div>
     <div class="col-1 text-right">
      <button type="button" class="btn btn-success" style="min-height:56px;" @click="saveComment"><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>  
     </div>
    </div>
      <hr style="border-color: #ededed;">
<div class="timeline" v-for="ResultLogsAllRes in ResultLogsAll" v-bind:key="ResultLogsAllRes">
  <div class="container left">
    <div class="content">
              <div class="col-12">
                          <label class="labeldate">{{ResultLogsAllRes.created_at}}</label>
                           <div v-for="AllRes in ResultLogsAllRes.ResultLogsAll" v-bind:key="AllRes">
                          <div class="row">
                          <div class="col-3" style="align-self: center;"><h5>{{AllRes.created_at}}</h5></div>
                          <div class="col-5" style="white-space:nowrap;"><h5> {{AllRes.description}} {{AllRes.idOrdine}}</h5>
                         </div>
                          <div class="col-4 text-right" style="white-space:nowrap;">
                          <h5>{{AllRes.name}} {{AllRes.surname}}</h5>
                          </div>
                          </div>                    
            </div></div>
    </div>
  </div>
<!--
<div v-if ="ResultLogsAllRes.idOrdine > 0"> 
  <div class="timeline1">
 <div class="container1 left">
       <div class="content">
              <div class="col-12">
                          <label class="labeldate">{{ResultLogsAllRes.created_at}}</label>
                           <div v-for="AllRes in ResultLogsAllRes.ResultLogsAll" v-bind:key="AllRes">
                          <div class="row">
                          <div class="col-3" style="align-self: center;"><h5>{{AllRes.created_at}}</h5></div>
                          <div class="col-5" style="white-space:nowrap;"><h5>{{AllRes.description}}</h5>
                         </div>
                          <div class="col-4 text-right" style="white-space:nowrap;">
                          <h5>Ordine Numero: {{AllRes.idOrdine}} - {{AllRes.name}} - {{AllRes.surname}}</h5>
                          </div>
                          </div>                    
            </div></div>
    </div>
  </div>
</div></div>
   --->
</div>
<!--
<div class="timeline1">
  <div class="container1 left">
    <div class="content">
              <div class="col-12">
                           <div v-for="AllResOrder in ResultLogsAllOrder" v-bind:key="AllResOrder">
                          <div class="row">
                          <div class="col-3" style="align-self: center;"><h5>{{AllResOrder.created_at}}</h5></div>
                          <div class="col-5" style="white-space:nowrap;"><h5>{{AllResOrder.description}}</h5>
                         </div>
                          <div class="col-4 text-right" style="white-space:nowrap;">
                          <h5>{{AllResOrder.name}} {{AllResOrder.surname}}</h5>
                            <h5>Ordine Numero: {{AllResOrder.idOrdine}}</h5>
                          </div>
                          </div>                    
            </div></div>
    </div>
  </div>
</div> --->
                            
                        <div class="container-fluid">
                          <div class="row">
                          <div class="col-12 text-right">
                             <button
                                id="btnCancelNew"
                                type="button"
                                class="btn btn-danger"
                                @click="cancelNewUser"
                              >
                                <i class="fa fa-times"></i>
                                <span>{{ cancel }}</span>
                              </button>                             
                              </div>
                           </div>
                     </div>                     
                </div> 
            </div>   <!-- end detail timeline --->
            


            <!-- detail address --->
                       <div class="card-body tab-pane" id="detailAddress" role="tabpanel" style="padding:2rem;box-shadow:none!important;padding-top: 0px;"> 
                      <div class="row">
                      <div v-if="rowIdSelectedAddress > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                        <pageDetail
                        functions="adminSettingUserAddress"
                        :configurations="detailAddressConfiguration"
                        :jsonValue="detailValuesAdress"
                        ></pageDetail>
                      </div>
                      <div class="row">
                        <div class="col-12 text-right" style="margin-top: 8px;padding: 0px;">
                          <button
                            type="button"
                            class="btn btn-danger"
                            data-dismiss="modal"
                            @click="cancelNewAddress"
                          ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="saveNewAddress"
                          ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                        </div>
                        </div>
                      </div>   <!-- end detail address ---> 
<!--- end dettaglio Indirizzi --->             
        </div>
      </div>
    </div>
    <div class="modal fade" id="passwordModal" tabindex="-1" role="dialog" aria-labelledby="passwordModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="passwordModalLabel">Modifica password utente: <b style="text-transform:uppercase;">{{ usernameChange }}</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form id="frmChangePassword" name="frmChangePassword">
              <label for="newPassword">Nuova password</label>
              <input type="password" id="newPassword" name="namePassword" required class="form-control">
              <label for="confirmNewPassword">Conferma Nuova password</label>
              <input type="password" id="confirmNewPassword" name="confirmNewPassword" required class="form-control">
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Annulla</button>
            <button type="button" class="btn btn-success" @click="saveNewPassword">Cambia password</button>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminSettingUser",
  components: {
    BootstrapTable,
    Select2,
    PageDetail
  },
  data() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      confirmDeleteRowSelected: dictionaryHelpers.getDictionary(
        "ConfirmDeleteRowSelected"
      ),
      confirmSaveRowSelected: dictionaryHelpers.getDictionary(
        "ConfirmSaveRowSelected"
      ),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfigurations: [],
      DetailReferentConfiguration:[],
      detailSalesUserConfiguration:[],
      tableCartRulesUsersConfiguration:[],
      tableDataRole: [],
      tableDataUserGroup: [],
      tableResult: [],
      ResultLogsAll: [],
      ResultLogsAllOrder: [],
      nameUser: '',
      detailValues: {},
      detailValuesReferent: {},
      detailValuesAdress: {},
      detailValuesSalesUser: {},
      disableButton: true,
      disableAddGroupButton: true,
      disableRemoveGroupButton: true,
      disableTab: true,
      confirmed: true,
      confirmed_referent: true,
      groups: dictionaryHelpers.getDictionary("Groups"),
      idFormNewUser: "frmadminSettingUser",
      idTabAdminSettingUser: "tabAdminSettingUser",
      idTabGroupBody: "tabGroupBody",
      idTabNewUserBody: "tabNewUserBody",
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newUser: dictionaryHelpers.getDictionary("NewUser"),
      remove: dictionaryHelpers.getDictionary("Remove"),
      rowsSelected: 0,
      rowIdSelected: 0,
      rowIdSelectedAddress: 0,
      rowIdSelectedReferent: 0,
      rowIdSelectedCartRules: 0,
      save: dictionaryHelpers.getDictionary("Save"),
      spanRowSelected: "",
      ResultLogs: [],
      tableGroupsDisabledConfiguration: [],
      DetailAddressConfiguration: [],
      detailAddressConfiguration: [],
      tableGroupsDisabledData: [],
      tableGroupsEnabledConfiguration: [],
      tableGroupsEnabledData: [],
      tableUserHistoricalData: [],
      tableUsersConfiguration: [],
      tableAddressConfiguration: [],
      tableUserHistoricalConfiguration: [],
      UsersReferentConfiguration: [],
      checkInsert: false,
      tableUserData: [],
      tableUserResult: [],
      tableUserReferentData: [],
      tableAddressData: [],
      tableAddressResult: [],
      tableUserReferentResult: [],
      tableCartRulesUsersResult: [],
      tableUserHistoricalResult: [], 
      tableCartRulesUsersData: [],
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      url: window.location.pathname,
      user: dictionaryHelpers.getDictionary("User"),
      users: dictionaryHelpers.getDictionary("Users"),
      usernameChange: ''
    };
  },
  created() {
    spinnerHelpers.show();
    this.loadConfiguration();
  },
  methods: {
    /***   USER   ***/

    loadConfiguration() {
      var adminSettingUser = this;
     // server 0 0 3 4 1 2 3 2 1 5 6 
     //local 0 0 2 3 1 2 3 1 2 6 7 

      adminConfigurationServices.getFunctionality(function(result) {
        if (
          functionHelpers.isValued(result) &&
          functionHelpers.isValued(result.data) &&
          functionHelpers.isValued(result.data)
        ) {
         
          adminSettingUser.tableUsersConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
          adminSettingUser.detailConfigurations = result.data.tabsConfigurations[0].pageConfigurations;

          adminSettingUser.tableGroupsEnabledConfiguration = result.data.tablesConfigurations[3].tablesConfigurations;
          adminSettingUser.tableGroupsDisabledConfiguration = result.data.tablesConfigurations[4].tablesConfigurations;

          adminSettingUser.detailAddressConfiguration = result.data.tabsConfigurations[2].pageConfigurations; 
          adminSettingUser.tableAddressConfiguration = result.data.tablesConfigurations[1].tablesConfigurations;

          adminSettingUser.detailSalesUserConfiguration = result.data.tabsConfigurations[3].pageConfigurations; 

          adminSettingUser.DetailReferentConfiguration = result.data.tabsConfigurations[1].pageConfigurations; 
          adminSettingUser.UsersReferentConfiguration = result.data.tablesConfigurations[2].tablesConfigurations; 

          adminSettingUser.tableCartRulesUsersConfiguration = result.data.tablesConfigurations[5].tablesConfigurations;
          adminSettingUser.tableUserHistoricalConfiguration = result.data.tablesConfigurations[6].tablesConfigurations;

          //local
         /* adminSettingUser.tableUsersConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
          adminSettingUser.detailConfigurations = result.data.tabsConfigurations[0].pageConfigurations;     
          adminSettingUser.tableGroupsEnabledConfiguration = result.data.tablesConfigurations[2].tablesConfigurations;
          adminSettingUser.tableGroupsDisabledConfiguration = result.data.tablesConfigurations[3].tablesConfigurations;
          adminSettingUser.detailAddressConfiguration = result.data.tabsConfigurations[1].pageConfigurations; 
          adminSettingUser.DetailReferentConfiguration = result.data.tabsConfigurations[2].pageConfigurations; 
          adminSettingUser.detailSalesUserConfiguration = result.data.tabsConfigurations[3].pageConfigurations; 
          adminSettingUser.UsersReferentConfiguration = result.data.tablesConfigurations[1].tablesConfigurations; 
          adminSettingUser.tableAddressConfiguration = result.data.tablesConfigurations[2].tablesConfigurations;
          adminSettingUser.tableCartRulesUsersConfiguration = result.data.tablesConfigurations[6].tablesConfigurations;
          adminSettingUser.tableUserHistoricalConfiguration = result.data.tablesConfigurations[7].tablesConfigurations;*/
          
          console.log(result.data);
          $.each(adminSettingUser.detailConfigurations, function(
            i,
            configuration
          ) {
            if (configuration.field == "password") {
              configuration.required = true;
            }
          });
        }
        adminSettingUser.loadTableData();
      });
    },
   userFormatter(value, row, index, field) {
      var adminSettingUser = this;
      var html =
        '<div class="container-fluid nopadding" style="min-width:80px;">';
      html +=
        '<button class="btn btn-success" onclick="adminSettingUser.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';      
          html +=
        '<button class="btn btn-danger" onclick="adminSettingUser.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
        html +=
        '<button class="btn btn-primary" onclick="adminSettingUser.__vue__.openPopUpChangePassword(' +
        row.id +
        ')"><i class="fa fa-lock"/></button>';

      if (functionHelpers.isValued(this.tableUserResult)) {
        $.each(this.tableUserResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminSettingUser.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div>";
      return html;
    },

     DefaultAddressFormatter(value, row, index, field){
      var adminSettingUser = this;  

        if(row.DefaultAddress){
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminSettingUser.__vue__.onChangeCheckDetailDefaultAddress(' + row.code + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }else{
          var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminSettingUser.__vue__.onChangeCheckDetailDefaultAddress(' + row.code + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }
        return newList;
      },

       onChangeCheckDetailDefaultAddress(id) {
          var adminSettingUser = this;
          var data = {
            id: id,
            user_id: this.rowIdSelected,
          };
          userServices.updateCheckDetailDefaultAddress(data, function (result) {
            notificationHelpers.success("Aggiornamento avvenuto correttamente");
             adminSettingUser.ontabadminSettingAddressButton();
          });
        },


      OnlineReferentFormatter(value, row, index, field){
      var adminSettingUser = this;  
       if(row.online){
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminSettingUser.__vue__.onChangeCheckOnlineReferentDetail(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }else{
          var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminSettingUser.__vue__.onChangeCheckOnlineReferentDetail(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }
        return newList;
      },

       onChangeCheckOnlineReferentDetail(id) {
          var adminSettingUser = this;
          var data = {
            id_people: id,
            user_id: this.rowIdSelected, 
          };
    
          userServices.updateCheckOnlineReferentDetail(data, function (result) {
            notificationHelpers.success("Aggiornamento avvenuto correttamente");
             adminSettingUser.ontabadminSettingUserReferentButton();
          });
        },
  


       OnlineFormatter(value, row, index, field){
      var adminSettingUser = this;  
        if(row.Online){
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminSettingUser.__vue__.onChangeCheckOnlineDetail(' + row.code + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }else{
          var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminSettingUser.__vue__.onChangeCheckOnlineDetail(' + row.code + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
        }
        return newList;
      },

      onChangeCheckOnlineDetail(id) {
          var adminSettingUser = this;
          var data = {
            id: id,
            user_id: this.rowIdSelected,
          };
          userServices.updateCheckOnlineAddress(data, function (result) {
            notificationHelpers.success("Aggiornamento avvenuto correttamente");
             adminSettingUser.ontabadminSettingAddressButton();
          });
        },
  

      AddressFormatter(value, row, index, field) {
          var adminSettingUser = this;
          var html =
            '<div class="container-fluid nopadding" style="min-width:80px;">';
          html +=
            '<button class="btn btn-success" onclick="adminSettingUser.__vue__.executeOpenDetailAddress(' +
            row.code +
            ')"><i class="fa fa-pencil" title="' +
            this.openDetail +
            '" /></button>';      
              html +=
            '<button class="btn btn-danger" onclick="adminSettingUser.__vue__.deleteDetailAddress(' +
            row.code +
            ')"><i class="fa fa-trash"/></button>';
      
          if (functionHelpers.isValued(this.tableAddressResult)) {
            $.each(this.tableAddressResult, function(i, result) {
              if (result.id == row.code) {
                if (result.success) {
                  html +=
                    '<div class="col-1"><i class="fa fa-check text-success" title="';
                  if (functionHelpers.isValued(result.message)) {
                    html += result.message;
                  } else {
                    html += adminSettingUser.updateCompleted;
                  }
                  html += '" /></div>';
                } else {
                  html +=
                    '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                    result.message +
                    '" /></div>';
                }
                return;
              }
            });
          }
          html += "</div>";
          return html;
        },

        CartRulesUsersFormatter(value, row, index, field) {
          var adminSettingUser = this;
          var html =
            '<div class="container-fluid nopadding" style="min-width:80px;">';
          html +=
            '<button class="btn btn-success" onclick="adminSettingUser.__vue__.executeOpenCartRulesUsers(' +
            row.id +
            ')"><i class="fa fa-pencil" title="' +
            this.openDetail +
            '" /></button>';      
              html +=
            '<button class="btn btn-danger" onclick="adminSettingUser.__vue__.deleteCartRulesUsers(' +
            row.id +
            ')"><i class="fa fa-trash"/></button>';  
          if (functionHelpers.isValued(this.tableCartRulesUsersResult)) {
            $.each(this.tableCartRulesUsersResult, function(i, result) {
              if (result.id == row.id) {
                if (result.success) {
                  html +=
                    '<div class="col-1"><i class="fa fa-check text-success" title="';
                  if (functionHelpers.isValued(result.message)) {
                    html += result.message;
                  } else {
                    html += adminSettingUser.updateCompleted;
                  }
                  html += '" /></div>';
                } else {
                  html +=
                    '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                    result.message +
                    '" /></div>';
                }
                return;
              }
            });
          }
          html += "</div>";
          return html;
        },

   executeOpenCartRulesUsers(id) {
      window.location.href = "/admin/sales/cartrules?id=" + id;
    },

    executeOpenNewCartRuleUser() {
       window.location.href = "/admin/sales/cartrules?id=0";
    },

  UserHistoricalFormatter(value, row, index, field) {
          var adminSettingUser = this;
          var html =
            '<div class="container-fluid nopadding" style="min-width:80px;">';
          html +=
            '<button class="btn btn-success" onclick="adminSettingUser.__vue__.executeOpenUserHistorical(' +
            row.code +
            ')"><i class="fa fa-pencil" title="' +
            this.openDetail +
            '" /></button>';      
              html +=
            '<button class="btn btn-danger" onclick="adminSettingUser.__vue__.deleteOpenUserHistorical(' +
            row.id +
            ')"><i class="fa fa-trash"/></button>';  
          if (functionHelpers.isValued(this.tableUserHistoricalResult)) {
            $.each(this.tableUserHistoricalResult, function(i, result) {
              if (result.id == row.code) {
                if (result.success) {
                  html +=
                    '<div class="col-1"><i class="fa fa-check text-success" title="';
                  if (functionHelpers.isValued(result.message)) {
                    html += result.message;
                  } else {
                    html += adminSettingUser.updateCompleted;
                  }
                  html += '" /></div>';
                } else {
                  html +=
                    '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                    result.message +
                    '" /></div>';
                }
                return;
              }
            });
          }
          html += "</div>";
          return html;
        },

          executeOpenUserHistorical(code) {
            window.location.href = "/admin/sales/salesorders?id=" + code;
          },
          
    executeOpenDetailAddress(id) {
      spinnerHelpers.show();
      var adminSettingUser = this;
      this.rowIdSelectedAddress = id;
      userServices.getbyIdAddress(id, function(result) {
         adminSettingUser.detailValuesAdress = result.data;
      });

      $("#detailAddress").addClass("active");
      $("#tableReferent").removeClass("active");
      $("#tableAddress").removeClass("active");
      $("#detailReferent").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();

    },

    deleteDetailAddress(id){
      var adminSettingUser = this;
      if (confirm("Sei sicuro di voler eliminare?")) {
        adminSettingUser.executedeleteDetailAddress(id);
      }
    },
    executedeleteDetailAddress(id) {
      spinnerHelpers.show();
      var adminSettingUser = this;
        userServices.deleteAddress(id, function() {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        adminSettingUser.ontabadminSettingAddressButton();
      });
    },

    UserSettingReferentFormatter(value, row, index, field) {
          var adminSettingUser = this; 
          var html =
            '<div class="container-fluid nopadding" style="min-width:80px;">';
          html +=
            '<button class="btn btn-success" onclick="adminSettingUser.__vue__.executeOpenDetailReferent(' +
            row.id +
            ')"><i class="fa fa-pencil" title="' +
            this.openDetail +
            '" /></button>';      
          if (functionHelpers.isValued(this.tableUserReferentResult)) {
            $.each(this.tableUserReferentResult, function(i, result) {
              if (result.id == row.id) {
                if (result.success) {
                  html +=
                    '<div class="col-1"><i class="fa fa-check text-success" title="';
                  if (functionHelpers.isValued(result.message)) {
                    html += result.message;
                  } else {
                    html += adminSettingUser.updateCompleted;
                  }
                  html += '" /></div>';
                } else {
                  html +=
                    '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                    result.message +
                    '" /></div>';
                }
                return;
              }
            });
          }
          html += "</div>";
          return html;
        },

      executeOpenDetailReferent(id) {
      spinnerHelpers.show();
      var adminSettingUser = this;
      this.rowIdSelectedReferent = id;
      $.each(this.tableUserReferentData, function(i, row) {
        if (adminSettingUser.rowIdSelectedReferent == row.id) {
          adminSettingUser.detailValuesReferent = row;

           $("#username_referent").val(adminSettingUser.detailValuesReferent.username_referent);
         //  $("#password_referent").val(adminSettingUser.detailValuesReferent.password_referent);
           adminSettingUser.confirmed_referent = row.confirmed_referent;  
        }
      });
      
      $("#detailReferent").addClass("active");
      $("#tableReferent").removeClass("active");
      $("#tableAddress").removeClass("active");
      $("#detailAddress").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      spinnerHelpers.hide();
    },

      executeOpenDetail(id) {
      spinnerHelpers.show();
      $("#detailUser").addClass("active");
      $("#tableReferent").removeClass("active");
      
      var adminSettingUser = this;

      this.rowIdSelected = id;
      this.titleDetail = this.customer;
      $.each(this.tableUserData, function(i, row) {
        if (adminSettingUser.rowIdSelected == row.id) {
          adminSettingUser.detailValues = row;
          adminSettingUser.nameUser = row.username;
          $("#username").val(adminSettingUser.detailValues.username);
          adminSettingUser.confirmed = row.confirmed;  
          adminSettingUser.ResultLogs = row.ResultLogs;  
        }
      });
      $("#tabNewUserBody").addClass("active");
      $("#tableReferent").removeClass("active");
      $("#tabAdminSettingUser").removeClass("active");
      $("#tableAddress").removeClass("active");
      $("#detailAddress").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
    },

   ResetConfermationEmail(){
    var adminSettingUser = this;
    var data = {
              email: this.detailValues.email,
      };
    if (functionHelpers.isValued(this.detailValues.email)){
      userServices.ResetConfermationEmail(data, function (result) {
         notificationHelpers.success("E' stata inviata una mail all'indirizzo sopra compilato!");
      });  
    }else{
        notificationHelpers.error("Email non valorizzata!");
      }
    },

    ResetPassword(){
    var adminSettingUser = this;
    var data = {
              email: this.detailValues.email,
      };
    if (functionHelpers.isValued(this.detailValues.email)){
      userServices.rescuePassword(data, function (result) {
         notificationHelpers.success("E' stata inviata una mail all'indirizzo sopra compilato!");
      });  
    }else{
        notificationHelpers.error("Email non valorizzata!");
      }
    },

    ResetPasswordReferent(){
    var adminSettingUser = this;

    var data = {
              email: this.detailValuesReferent.email_referent,
      };

    if (functionHelpers.isValued(this.detailValuesReferent.email)){
      userServices.rescuePassword(data, function (result) {
         notificationHelpers.success("E' stata inviata una mail all'indirizzo sopra compilato!");
      });  
    }else{
        notificationHelpers.error("Email non valorizzata!");
      }
    },


    ResetConfermationEmailReferent(){
      var adminSettingUser = this;
    var data = {
              email: this.detailValuesReferent.email_referent,
      };
    if (functionHelpers.isValued(this.detailValuesReferent.email)){
      userServices.ResetConfermationEmail(data, function (result) {
         notificationHelpers.success("E' stata inviata una mail all'indirizzo sopra compilato!");
      });  
    }else{
        notificationHelpers.error("Email non valorizzata!");
      }
    },

saveNewSalesUser(){
  var adminSettingUser = this;
      if (
        functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
          this.detailValuesSalesUser.user_id = this.rowIdSelected;
          userServices.updateSalesUser(this.detailValuesSalesUser, function(result) {
          notificationHelpers.success(adminSettingUser.updateCompleted);
           adminSettingUser.ontabadminSettingSalesUserButton();
        });
      } 
},

    saveComment(){
      var adminSettingUser = this;
     // this.rowIdSelected = id;
      var id_user = adminSettingUser.rowIdSelected;
        var data = {
        id_user : id_user,
        comment : $('#comment').val()
      }
          userServices.insertComment(data, function(result) {
          notificationHelpers.success(adminSettingUser.insertCompleted);
          adminSettingUser.ontabadminSettingUserTimeLineButton();          
        });
     },


   delete(id) {
     if(confirm('Sei sicuro di voler eliminare l\'utente?')){
        var adminSettingUser = this;
        var ln = adminSettingUser.languages;
        spinnerHelpers.show();
        userServices.del(id, function() {
          notificationHelpers.success(
            dictionaryHelpers.getDictionary("DeleteCompleted")
          );
          
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminSettingUser.loadTableData(ln);
          window.scrollTo(0, 0);
        });
      }
    },
    loadTableData() {
      var adminSettingUser = this;
      this.disableButton = true;
      adminSettingUser.checkInsert = false;

      userServices.getAll(function(result) {
        adminSettingUser.tableUserData = result.data;
        $("#detailRole").removeClass("active");
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();

      });
    },

    onTableCheckUser() {
      var countRowSelected = this.$refs.tableUser.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
        this.disableTab = true;
      } else {
        if (countRowSelected == 1) {
          this.disableTab = false;
        } else {
          this.disableTab = true;
        }
        this.disableButton = false;
      }
    },
    confirmSaveUser() {
      if (this.$refs.tableUser.haveRowSelected(true)) {
        if (confirm(this.confirmSaveRowSelected)) {
          spinnerHelpers.show();
          this.updateUser();
        }
      }
    },
    updateUser() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableUser.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

        adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
        userServices.update(rowToSave,function() {
            adminSettingUser.checkAllIsSaved();
            adminSettingUser.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminSettingUser.updateCompleted);
          },
          function(response) {
            adminSettingUser.checkAllIsSaved();
            adminSettingUser.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },
    confirmDeleteUser() {
      if (this.$refs.tableUser.haveRowSelected(true)) {
        if (confirm(this.confirmDeleteRowSelected)) {
          spinnerHelpers.show();
          this.deleteUser();
        }
      }
    },
    deleteUser() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableUser.getRowSelected(), function(i, row) {
        adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
        userServices.del(
          row.id,
          function(id) {
            adminSettingUser.checkAllIsSaved();
            adminSettingUser.tableResult.push({ id: id, success: true });
            notificationHelpers.success(adminSettingUser.deleteCompleted);
          },
          function(response, id) {
            adminSettingUser.checkAllIsSaved();
            adminSettingUser.tableResult.push({
              id: id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },
  

    openPopUpChangePassword(id){
      var adminSettingUser = this;
      this.rowIdSelected = id;
      $.each(this.tableUserData, function(i, row) {
        if (id == row.id) {
          adminSettingUser.usernameChange = row.username;
        }
      });
      $('#passwordModal').modal('show');
    },
    saveNewPassword(){
      spinnerHelpers.show();
      var adminSettingUser = this;
      var id = adminSettingUser.rowIdSelected;

      var data = {
        id : id,
        password : $('#newPassword').val()
      }

      if($('#newPassword').val() == $('#confirmNewPassword').val()){
        if (functionHelpers.isValued(data.password)) {
          userServices.changePassword(data,function(response) {
            $('#passwordModal').modal('hide');
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });
        }
      }else{
        notificationHelpers.error("Le password inserite non coincidono!");
      }
      spinnerHelpers.hide();
    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.loadTableData();
      }
    },

    ontabadminSettingUserButton() {    
        $("#detailUser").addClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailtableReferent").removeClass("active"); 
        $("#detailRole").removeClass("active");
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active"); 
        $("#tabledetailSalesUser").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
    },

    ontabAdminRoleSettings: function () {
      var adminSettingUser = this;
        $("#detailRole").addClass("active");
        $("#detailUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailtableReferent").removeClass("active"); 
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");

      data = {
        sUserId: storageData.sUserId(),
        rowSelected: this.rowIdSelected,
      };
        roleServices.getAllByRole(data, function(result) {  
        adminSettingUser.tableDataRole = result.data;
        spinnerHelpers.hide();
      }); 
      
      groupNewsletterServices.getAllByUserGroup(data, function(result) {  
        console.log(result.data);
        adminSettingUser.tableDataUserGroup = result.data;
        spinnerHelpers.hide();

      });

    },

    onChangeUserRole(idRoleUser) {
      var adminSettingUser = this;
     
      if ($("#check" + idRoleUser).is(":checked")) {
        var data = {
          idRoleUser: idRoleUser,
          user_id: this.rowIdSelected,
        };
      /* insert */
      roleServices.insertRole(data, function(result) {  
        notificationHelpers.success(adminSettingUser.insertCompleted); 
      }); 
      } else {
        /* delete */
       roleServices.delRoleUser(idRoleUser, adminSettingUser.rowIdSelected, function (result) {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted")); 
      });
      }
    },

    onChangeUserGroup(idGroupUser) {
      var adminSettingUser = this;
      if ($("#checkUserGroup" + idGroupUser).is(":checked")) {
        var data = {
          idGroupUser: idGroupUser,
          user_id: this.rowIdSelected,
        };
      /* insert */
      groupNewsletterServices.insertGroupUser(data, function(result) {  
        notificationHelpers.success(adminSettingUser.insertCompleted); 
      }); 
      } else {
        /* delete */
       groupNewsletterServices.delGroupUser(idGroupUser, adminSettingUser.rowIdSelected, function (result) {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted")); 
      });
      }
    },

    ontabadminSettingAddressButton() {
    var adminSettingUser = this;
    spinnerHelpers.show();
    var rowSelected = this.rowIdSelected;
        userServices.getAllAddress(rowSelected,function(result) {
            adminSettingUser.tableAddressData = result.data;
            spinnerHelpers.hide(); 
    }); 
        $("#tableAddress").addClass("active");
        $("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active");
        $("#detailUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailRole").removeClass("active");  
        $("#detailAddress").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();
  },

    ontabadminSettingUserReferentButton() {
      var adminSettingUser = this;
       spinnerHelpers.show();
      var rowSelected = this.rowIdSelected;   
        peopleServices.getAllReferent(rowSelected,function(result) {
          adminSettingUser.tableUserReferentData = result.data;
          spinnerHelpers.hide(); 
        });  
        $("#detailtableReferent").addClass("active");
        $("#tableReferent").addClass("active");
        $("#detailUser").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailRole").removeClass("active");  
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
    },

    ontabadminSettingSalesUserButton() {
      var adminSettingUser = this;
      spinnerHelpers.show();
      var rowSelected = this.rowIdSelected; 
      userServices.getAllUserSales(rowSelected,function(result) {
      adminSettingUser.tableCartRulesUsersData = result.data;
      spinnerHelpers.hide(); 
      });  
      userServices.getAllDetailValueSalesUser(rowSelected,function(result) {
       adminSettingUser.detailValuesSalesUser = result.data[0];
        console.log(result.data);
        spinnerHelpers.hide(); 
      });  
        $("#tabledetailSalesUser").addClass("active");
        $("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active");
        $("#detailUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailRole").removeClass("active");  
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();
    },

    ontabadminSettingUserTimeLineButton() {
    var adminSettingUser = this; 
    spinnerHelpers.show();
    var rowSelected = this.rowIdSelected; 

      userServices.getAllDetailTimeLine(rowSelected,function(result) {
       console.log(result);
       adminSettingUser.ResultLogsAll = result.data;
       // adminSettingUser.ResultLogsAllOrder = result.data;

     
        $("#tabledetailTimeline").addClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active");
        $("#detailUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailRole").removeClass("active");  
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        spinnerHelpers.hide();
      });
       
    },


    ontabadminSettingUserhistoricalButton() {
     var adminSettingUser = this;
      spinnerHelpers.show();
      var rowSelected = this.rowIdSelected; 
      userServices.getAllUserHistorical(rowSelected,function(result) {
      adminSettingUser.tableUserHistoricalData = result.data;
      spinnerHelpers.hide(); 
      }); 
        $("#tabledetailUserHistorical").addClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        $("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active");
        $("#detailUser").removeClass("active");
        $("#detailReferent").removeClass("active");
        $("#detailRole").removeClass("active");  
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();

    },



     onTabGroup() {
      var adminSettingUser = this;
      spinnerHelpers.show();
      var rowSelected = this.$refs.tableUser.getRowSelected()[0];
      this.spanRowSelected = rowSelected.username;
      roleServices.getByUser(rowSelected.id, function(result) {
        adminSettingUser.tableGroupsEnabledData = result.data.included;
        adminSettingUser.tableGroupsDisabledData = result.data.excluded;
        spinnerHelpers.hide();
      });
      this.disableAddGroupButton = true;
      this.disableRemoveGroupButton = true;
    },

    onTabNewAddress() {
     spinnerHelpers.show();
        this.detailValuesAdress = {};

        $("#detailAddress").addClass("active");
        $("#detailUser").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        //$("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active"); 
        $("#detailReferent").removeClass("active");          
        $("#detailRole").removeClass("active");
        $("#tableAddress").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();  
    },

    onTabNewReferent() {
        spinnerHelpers.show();
        this.detailValuesReferent = {};
        $("#detailUser").removeClass("active");
        $("#tabledetailSalesUser").removeClass("active");
        //$("#detailtableReferent").removeClass("active");
        $("#tableReferent").removeClass("active");       
        $("#detailReferent").addClass("active");
        $("#detailRole").removeClass("active");
        $("#tableAddress").removeClass("active");
        $("#detailAddress").removeClass("active");
        $("#tabledetailUserHistorical").removeClass("active");
        $("#tabledetailTimeline").removeClass("active");
        spinnerHelpers.hide();
        },

    onTabUser() {
      spinnerHelpers.show();
      this.detailValues = {};
      spinnerHelpers.hide();
    },
    onTabNewUser() {
      var adminSettingUser = this;
      spinnerHelpers.show();

      this.checkInsert = true;
      adminSettingUser.rowIdSelected = 0;
      this.detailValues = {};
      $("#" + this.idTabNewUserBody).addClass("active");
      $("#" + this.idTabAdminSettingUser).removeClass("active");
      $("#tableAddress").removeClass("active");

      spinnerHelpers.hide();
    },
    cancelNewUser() {
      spinnerHelpers.show();
      var adminSettingUser = this;
      this.detailValues = {};
      $("#" + this.idTabAdminSettingUser).addClass("active");
      $("#" + this.idTabNewUserBody).removeClass("active");
      this.nameUser = '';
      $("#detailRole").removeClass("active");
      $("#tableReferent").removeClass("active");
      $("#tableAddress").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
     
      
    },

      cancelNewUsers() {
      spinnerHelpers.show();
      this.detailValues = {};
      $("#tableReferent").addClass("active");
      $("#detailUser").removeClass("active");
      $("#detailReferent").removeClass("active");
      $("#detailRole").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tableAddress").removeClass("active");
      $("#detailAddress").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
    },

    saveNewReferent() {
    spinnerHelpers.show();
    var adminSettingUser = this;
    this.detailValuesReferent.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

     var confirmed_referent = false;
      if ($("#confirmed_referent").is(":checked")) {
        confirmed_referent = true;
      } else {
        confirmed_referent = false;
      }

        this.detailValuesReferent.username_referent = $("#username_referent").val();
        this.detailValuesReferent.password_referent = $("#password_referent").val();
        this.detailValuesReferent.confirm_password_referent = $("#confirm_password_referent").val();
        this.detailValuesReferent.confirmed_referent = confirmed_referent;

      if (!functionHelpers.isValued(this.detailValuesReferent.code)) {
              this.detailValuesReferent.code = false;
            }

      if (!functionHelpers.isValued(this.detailValuesReferent.description)) {
        this.detailValuesReferent.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailValuesReferent.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailValuesReferent.idLanguage = this.languages;
      }

    if (this.detailValuesReferent.password_referent != this.detailValuesReferent.confirm_password_referent){
          notificationHelpers.error("Attenzione, la password inserita non coincide con quella di conferma! Riprova;");
          spinnerHelpers.hide();
      }else{

      if (functionHelpers.isValued(this.rowIdSelectedReferent) &&
        this.rowIdSelectedReferent > 0
      ) {
      this.detailValuesReferent.id = this.rowIdSelectedReferent;
          peopleServices.update(this.detailValuesReferent, function(result) {
          adminSettingUser.tableUserReferentResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.updateCompleted
          });
          notificationHelpers.success(adminSettingUser.updateCompleted);
          adminSettingUser.ontabadminSettingUserReferentButton();
        });
      } else {
          this.detailValuesReferent.user_id = this.rowIdSelected;
        peopleServices.insert(this.detailValuesReferent, function(result) {
          adminSettingUser.tableUserReferentResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.insertCompleted
          });
          notificationHelpers.success(adminSettingUser.insertCompleted);
          adminSettingUser.ontabadminSettingUserReferentButton();   
   });
      }
  }
    },

  saveNewAddress() {
    var adminSettingUser = this;
      if (
        functionHelpers.isValued(this.rowIdSelectedAddress) &&
        this.rowIdSelectedAddress > 0
      ) {
     // this.detailValuesAdress.id = this.rowIdSelectedAddress;
          userServices.updateUserAddress(this.detailValuesAdress, function(result) {
          adminSettingUser.tableAddressResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.updateCompleted
          });
          notificationHelpers.success(adminSettingUser.updateCompleted);
           adminSettingUser.ontabadminSettingAddressButton();
        });
      } else {
        this.detailValuesAdress.user_id = this.rowIdSelected;
        userServices.insertUserAddress(this.detailValuesAdress, function(result) {
          adminSettingUser.tableAddressResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.insertCompleted
          });
          notificationHelpers.success(adminSettingUser.insertCompleted);
          adminSettingUser.ontabadminSettingAddressButton();          
    });
  }
  },
    cancelNewAddress() {
      spinnerHelpers.show();
      this.detailValuesAdress = {};
      $("#tableAddress").addClass("active");
      $("#tableReferent").removeClass("active");
      $("#detailUser").removeClass("active");
      $("#detailReferent").removeClass("active");
      $("#detailRole").removeClass("active");
      $("#detailAddress").removeClass("active");
      $("#tabledetailSalesUser").removeClass("active");
      $("#tabledetailUserHistorical").removeClass("active");
      $("#tabledetailTimeline").removeClass("active");
      spinnerHelpers.hide();
  },


    saveNewUser() {
    spinnerHelpers.show();
      var adminSettingUser = this;
      this.detailValues.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      var confirmed = false;
      if ($("#confirmed").is(":checked")) {
        confirmed = true;
      } else {
        confirmed = false;
      }

        this.detailValues.username = $("#username").val();
        this.detailValues.password = $("#password").val();
        this.detailValues.confirm_password = $("#confirm_password").val();
        this.detailValues.confirmed = confirmed;

      if (!functionHelpers.isValued(this.detailValues.code)) {
        this.detailValues.code = false;
      }
      if (!functionHelpers.isValued(this.detailValues.description)) {
        this.detailValues.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailValues.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailValues.idLanguage = this.languages;
      }
      if (this.detailValues.password != this.detailValues.confirm_password){
          notificationHelpers.error("Attenzione, la password inserita non coincide con quella di conferma! Riprova;");
          spinnerHelpers.hide();
      }else{
      if (functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0) {
        this.detailValues.id = this.rowIdSelected;
        userServices.update(this.detailValues, function(result) {
          adminSettingUser.tableUserResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.updateCompleted
          });
          notificationHelpers.success(adminSettingUser.updateCompleted);
          adminSettingUser.loadTableData(adminSettingUser.languages);
          $("#tabAdminSettingUser").addClass("active");
          $("#tabNewUserBody").removeClass("active");
          this.nameUser = '';
        });
      } else {
        userServices.insert(this.detailValues, function(result) {
          adminSettingUser.tableUserResult.push({
            id: result.data,
            success: true,
            message: adminSettingUser.insertCompleted
          });
          notificationHelpers.success(adminSettingUser.insertCompleted);

          if(adminSettingUser.checkInsert){
            spinnerHelpers.hide();
            adminSettingUser.checkInsert = false;
            adminSettingUser.rowIdSelected = result.data;
          }else{
            adminSettingUser.loadTableData(adminSettingUser.languages);
            $("#tabAdminSettingUser").addClass("active");
            $("#tabNewUserBody").removeClass("active");
            this.nameUser = '';
          }

         /* adminSettingUser.loadTableData(adminSettingUser.languages);
          $("#tabAdminSettingUser").addClass("active");
          $("#tabNewUserBody").removeClass("active");
          this.nameUser = '';*/
      });
    }  
 }
  },

    /***  END USER   ***/

    /***   GROUP   ***/
    onTabGroup() {
      var adminSettingUser = this;
      spinnerHelpers.show();
      var rowSelected = this.$refs.tableUser.getRowSelected()[0];
      this.spanRowSelected = rowSelected.username;
      roleServices.getByUser(rowSelected.id, function(result) {
        adminSettingUser.tableGroupsEnabledData = result.data.included;
        adminSettingUser.tableGroupsDisabledData = result.data.excluded;
        spinnerHelpers.hide();
      });
      this.disableAddGroupButton = true;
      this.disableRemoveGroupButton = true;
    },
    onTableGroupsDisabledCheck() {
      if (this.$refs.tableGroupsDisabled.countRowSelected() == 0) {
        this.disableAddGroupButton = true;
      } else {
        this.disableAddGroupButton = false;
      }
    },
    onTableGroupsEnabledCheck() {
      if (this.$refs.tableGroupsEnabled.countRowSelected() == 0) {
        this.disableRemoveGroupButton = true;
      } else {
        this.disableRemoveGroupButton = false;
      }
    },
    addGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableGroupsDisabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableGroupsDisabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          roleUserServices.insert(
            {
              idUser: adminSettingUser.$refs.tableUser.getRowSelected()[0].id,
              idRole: row.id,
              idFunctionality: menuHelpers.getIdFunctionByAdminUrl()
            },
            function(result) {
              adminSettingUser.checkAllGroupIsSaved();
              notificationHelpers.success(adminSettingUser.updateCompleted);
            }
          );
        });
      }
    },
    removeGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableGroupsEnabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableGroupsEnabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          roleUserServices.del(row.id, function(result) {
            adminSettingUser.checkAllGroupIsSaved();
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });
        });
      }
    },
    checkAllGroupIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        spinnerHelpers.hide();
        this.onTabGroup();
      }
    }

    /***   END GROUP   ***/
  }
};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
 position: absolute;
    z-index: 1;
    margin-top: 10px;
}

/*.nav-tabs .nav-item{
  width:25%;
}*/
.nav {
  border: 0px;
}
/*.nav-tabs .nav-link{
  width:100%;
  border-radius:0;
  color:#fff;
  background:#3c4b64;
  border-bottom:3px solid #f45f00 !important;
  border:0px;
}*/
/*.nav-tabs .nav-link.active{
  background:#2A3545 !important;
}

.nav-tabs .nav-link.active span{
  color:#fff;
}*/

/*.nav-tabs>.nav-item>.nav-link:not(.active){
  background:#3c4b64  !important;
}*/


/* end translate */
.nav-tabs .nav-item {
  width: 14.28%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}


/* time line */
* {
  box-sizing: border-box;
}

.timeline1{
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline1::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #ededed;
  top: 0;
  bottom: 0;
  left: -16%;
  margin-left: -5px;
}
.container1 {
    padding: 10px 31px;
    position: relative;
    background-color: inherit;
    width: 63%;
}

/* The circles on the timeline */
.container1::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: 866px;
  background-color: red;
  border: 4px solid #ededed;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}






/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #ededed;
  top: 0;
  bottom: 0;
  left: -16%;
  margin-left: -5px;
}

/* Container around content */
.container {
    padding: 10px 31px;
    position: relative;
    background-color: inherit;
    width: 63%;
}

/* The circles on the timeline */
.container::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: 866px;
  background-color: #00CED1;
  border: 4px solid #ededed;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 0%;
}

.content {
    padding: 12px 30px;
    width: 100%;
    left: -341px;
    background-color:#fff;
    position: relative;
    border-radius: 6px;
}

.labeldate {
    font-weight: bold;
    font-size: 13px;
    text-transform: uppercase;
}
/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
  left: 31px;
  }
  
  /* Full-width containers */
  .container {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  
  /* Make sure that all arrows are pointing leftwards */
  .container::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after, .right::after {
  left: 15px;
  }

  /* Make all right containers behave like the left ones */
  .right {
  left: 0%;
  }
}
/* end time line */

</style>
